import { render } from "./SuplierStatement.vue?vue&type=template&id=5fcff036&scoped=true"
import script from "./SuplierStatement.vue?vue&type=script&lang=js"
export * from "./SuplierStatement.vue?vue&type=script&lang=js"

import "./SuplierStatement.vue?vue&type=style&index=0&id=5fcff036&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fcff036"]])

export default __exports__